var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"o-autobuyer-btn o-autobuyer-btn--tiny",on:{"click":_vm.toggleMode}},[_vm._v(" "+_vm._s(_vm.modeDisplay)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }